"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = default_1;
const Printable_1 = require("../../models/printables/Printable");
const either_1 = require("../../types/either");
const updatePrintableLayerUserData_1 = __importDefault(require("./updatePrintableLayerUserData"));
const updateProjectVersion_1 = __importDefault(require("./updateProjectVersion"));
function default_1(project, action) {
  // Update the target printable + layer with user data from source
  const updateTargetAction = {
    type: 'UPDATE_PRINTABLE_LAYER_USER_DATA',
    projectId: action.projectId,
    printableId: action.printableId,
    layerId: action.targetLayerId,
    userData: action.targetUserData,
    timestamp: action.timestamp
  };
  const updateTargetPrintableUserDataResult = (0, updatePrintableLayerUserData_1.default)(project, updateTargetAction);
  if (updateTargetPrintableUserDataResult.isLeft()) {
    return (0, either_1.left)(updateTargetPrintableUserDataResult.value);
  }
  // Update the source printable + layer with user data from target
  const updateSourceAction = {
    type: 'UPDATE_PRINTABLE_LAYER_USER_DATA',
    projectId: action.projectId,
    printableId: action.sourcePrintableId,
    layerId: action.sourceLayerId,
    userData: action.sourceUserData,
    timestamp: action.timestamp
  };
  const updateSourcePrintableUserDataResult = (0, updatePrintableLayerUserData_1.default)(updateTargetPrintableUserDataResult.value.updatedProject, updateSourceAction);
  if (updateSourcePrintableUserDataResult.isLeft()) {
    return (0, either_1.left)(updateSourcePrintableUserDataResult.value);
  }
  // Update project version
  const updatedProject = (0, updateProjectVersion_1.default)(updateSourcePrintableUserDataResult.value.updatedProject, action);
  // Create list of updated entities from result of updatePrintableLayerUserData actions
  // (Note, filtering out the project entity since from the results because we want to include the one with the updated version instead)
  const updatedEntities = [...updateTargetPrintableUserDataResult.value.updatedEntities.filter(entity => (0, Printable_1.isPrintable)(entity)), ...updateSourcePrintableUserDataResult.value.updatedEntities.filter(entity => (0, Printable_1.isPrintable)(entity)), updatedProject];
  return (0, either_1.right)({
    updatedProject,
    updatedEntities
  });
}